import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";

interface TabProps {
  to: string;
  children: React.ReactNode;
}

export const Tab = ({ to, children }: TabProps) => {
  const [backgroundColor, setBackgroundColor] = useState<string>(
    colors.transparent
  );

  return (
    <NavLink
      to={to}
      className={(isActive) => {
        if (!isActive) {
          return;
        }
        return "d-flex align-items-center justify-content-center px-4 py-2";
      }}
      style={(isActive) => {
        if (!isActive) {
          return {
            backgroundColor: backgroundColor,
            textDecoration: "none",
            borderRadius: "4px",
            border: "solid 1px",
            borderColor: colors.transparent,
          };
        }
        return {
          backgroundColor: colors.white,
          borderColor: colors.ctaMain,
        };
      }}
      onMouseEnter={() => setBackgroundColor(colors.ctaLight)}
      onMouseLeave={() => setBackgroundColor(colors.transparent)}
    >
      {({ isActive }) => (
        <StyledText
          color={isActive ? colors.ctaMain : colors.textPrimary}
          className={`${
            isActive ? "bodyTextSemibold" : "bodyTextRegular"
          } mb-0`}
        >
          {children}
        </StyledText>
      )}
    </NavLink>
  );
};
